import { Fragment } from "react";
import { Grid } from "@mui/material";

import "../details components/nodes.css";
import Paper from "../../../components/Paper";
import ComponentHeader from "../../../components/ComponentHeader";
import WhenSelection from "./workflow nodes components/When";
import ConditionSelection from "./workflow nodes components/Condition";
import ActionSelection from "./workflow nodes components/ActionSelection";

export default function WorkflowNode({ formikProps }) {
  return (
    <Fragment>
      <Paper>
        <Grid item xs={12}>
          <ComponentHeader title={"Connect Nodes"} />
        </Grid>

        <Grid item xs={12}>
          <WhenSelection formikProps={formikProps} />

          <ConditionSelection formikProps={formikProps} />

          <ActionSelection formikProps={formikProps} />
        </Grid>
      </Paper>
    </Fragment>
  );
}
